import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export const SsoConfigFallback = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>
          <Skeleton className="h-5.5 w-30" />
        </CardTitle>
        <CardAction>
          <Skeleton className="h-9 w-21.5" />
        </CardAction>
        <CardDescription>
          <Skeleton className="h-5.5 w-250" />
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Skeleton className="h-6 w-60" />
      </CardContent>
    </Card>
  )
}
